import React from 'react';
import { Target } from 'lucide-react';

const OmegaSection = () => {
  return (
    <section style={{
      background: '#000000',
      padding: '100px 7.6923%',
      position: 'relative'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        <h2 className="section-title" style={{
          fontSize: '48px',
          fontWeight: 600,
          lineHeight: 1.1,
          letterSpacing: '-0.02em',
          color: '#FFFFFF',
          marginBottom: '60px',
          textAlign: 'center'
        }}>
          THE LIMIT
        </h2>

        <div className="two-col-grid" style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '60px',
          alignItems: 'center'
        }}>
          <div>
            <div className="title-with-icon" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              marginBottom: '24px'
            }}>
              <Target size={48} color="#00FFD1" />
              <h3 className="subsection-title" style={{
                fontSize: '32px',
                fontWeight: 600,
                lineHeight: 1.25,
                color: '#FFFFFF',
                margin: 0
              }}>
                The Omega Point as Physical Necessity
              </h3>
            </div>
            
            <p className="content-text" style={{
              fontSize: '18px',
              fontWeight: 400,
              lineHeight: 1.5,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '20px'
            }}>
              If the future acts as a boundary condition, what is that boundary? The mathematics forces a terminal closure object: a coherent limit of boundary data across an ever-growing family of causal diamonds—what we call G∞.
            </p>

            <p className="content-text" style={{
              fontSize: '18px',
              fontWeight: 400,
              lineHeight: 1.5,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '20px'
            }}>
              Not a heat-death endpoint. Not a featureless equilibrium. A stabilized, globally consistent closure of the universe's boundary conditions—an "Omega" in the strict sense that the system cannot be globally well-defined without some limiting closure structure.
            </p>

            <p className="content-text" style={{
              fontSize: '18px',
              fontWeight: 400,
              lineHeight: 1.5,
              color: 'rgba(255, 255, 255, 0.85)'
            }}>
              This is uncomfortable ground. It sounds like teleology—but the theory doesn't add goals, values, or outcome preferences. It only says: if the two-boundary formulation is correct, then global closure requires a terminal structure, whether we like the implications or not.
            </p>
          </div>

          <div className="section-image" style={{
            position: 'relative',
            height: '400px',
            borderRadius: '8px',
            overflow: 'hidden',
            border: '1px solid rgba(255, 255, 255, 0.25)'
          }}>
            <img 
              src="https://customer-assets.emergentagent.com/job_omega-theory/artifacts/7jl646jr_image%203%20The%20Limit.png" 
              alt="Omega Point Monolith"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                opacity: 0.9
              }}
            />
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: '80px',
              fontWeight: 700,
              color: '#00FFD1',
              textShadow: '0 0 20px rgba(0, 255, 209, 0.5)',
              fontFamily: 'monospace'
            }}>
              G∞
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 1024px) {
          section {
            padding: 60px 20px !important;
          }
          .section-title {
            font-size: 36px !important;
            margin-bottom: 40px !important;
          }
          .subsection-title {
            font-size: 28px !important;
          }
          .two-col-grid {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
          }
          .section-image {
            height: 300px !important;
          }
          .title-with-icon {
            flex-direction: column;
            align-items: flex-start !important;
          }
        }
        @media (max-width: 768px) {
          .section-title {
            font-size: 32px !important;
          }
          .subsection-title {
            font-size: 24px !important;
          }
          .content-text {
            font-size: 16px !important;
          }
          .section-image {
            height: 250px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default OmegaSection;
